/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Standard Filters Hook
 *
 * Provides consistent filtering patterns across all domain pages
 * including search, pagination, and filter state management.
 */

"use client";

export type {
  FilterRecord,
  StandardFiltersConfig,
  StandardFiltersReturn,
} from "./use-standard-filters/types";
export { useStandardFilters } from "./use-standard-filters/use-standard-filters-core";
